<template>
<!-- 文化资讯详情 -->
    <div class="information_detail_warp">
        <BaseDetail ref="baseDetail" >
            <template slot="cont" scope="{info}">
                <div class="cont_warp">
                    <div class="cont_header">
                        <div class="cont_header_title">{{info.title}}</div>
                        <div class="cont_header_date">
                            <span>{{info.venueName}}</span>
                            <span class="date">{{info.createTime}}</span>
                        </div>
                    </div>
                    <div v-html="info.info"></div>
                    <div class="behavior_box">
                        <div>浏览 0 </div>
                        <div class="behavior_list">
                            <div class="behavior_item" @click="praise">
                                <svg-icon icon-class="thumb" :class="operCount.ydz? 'active_icon': ''" class="item_icon" />
                                {{operCount.dzs}}
                            </div>
                            <div class="behavior_item" @click="collect">
                                <i class="el-icon-star-off item_icon" :class="operCount.ysc? 'active_icon': ''"  />
                                {{operCount.scs}}
                            </div>
                            <!-- <div class="behavior_item">
                                <i class="el-icon-share item_icon"/>
                                分享
                            </div> -->
                        </div>
                    </div>
                </div>
            </template>
        </BaseDetail>
        
    </div>
</template>

<script>
import BaseDetail from '@c/BaseDetail'
import { post } from '@u/request'
import { mapGetters } from 'vuex'

export default {
    name: 'informationDetail',
    components: {
        BaseDetail
    },
    data() {
        return {
            operCount: {}
        }
    },
    computed: {
        ...mapGetters([
            'readerId',
        ]),
        contentId() {
            return this.$route.params.id
        }
    },
    watch: {
	    'readerId'(value){
		    this.operinfo()
	    }
    },
    methods: {
        async praise() {
            
            if (!this.readerId) {
                this.$store.commit('SET_VISIBLE_LOGIN',true);
                return
            }
            if (this.operCount.ydz) {
                this.$message.success('已经点赞啦！');
                return;
            }
            const params = {
                readerId: this.readerId,
                contentId: this.contentId
            }
            const { data } = await post('resource/praise/add', params)
            this.$message.success('点赞成功！')
            this.operinfo()
        },
        async collect() {
            if (!this.readerId) {
                this.$store.commit('SET_VISIBLE_LOGIN',true);
                return
            }
            if (this.operCount.ysc) {
                this.$message.success('已经收藏啦！');
                return;
            }
            const params = {
                readerId: this.readerId,
                contentId: this.contentId
            }
            const { data } = await post('resource/collect/add', params)
            this.$message.success('收藏成功！')
            this.operinfo()
        },
        async operinfo() {
            const params = {
                readerId: this.readerId,
                contentId: this.contentId
            }
            const { data } = await post('resource/showapi/operinfo', params);
            this.operCount = data;
        }
    },
    
    mounted() {
        this.$refs.baseDetail.videoLoad('showcontent')
        this.$refs.baseDetail.loadCommentList('contentId')
        this.operinfo()
    }
}
</script>

<style scoped lang="scss">
.information_detail_warp {
    background: #f8f8f8;
    min-height: calc(100vh - 315px);
    .cont_warp {
        padding: 30px;
        .cont_header {
            color: #000;
            margin-bottom: 40px;
        }
        .cont_header_title {
            font-size: 24px;
            font-weight: 800;
        }
        .cont_header_date {
            display: flex;
            justify-content: space-between;
            padding: 40px 0;
            border-bottom: 1px solid #e5e5e5;
            font-size: 20px;
            .date {
                color: #777;
            }
        }
        .behavior_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #777;
            margin-top: 20px;
        }
        .behavior_list {
            margin-left: auto;
            display: flex;
            .behavior_item {
                width: 118px;
                height: 47px;
                line-height: 47px;
                text-align: center;
                border-radius: 5px;
                background: #f5f5f5;
                cursor: pointer;
                margin-left: 18px;
                
            }
        }
        .item_icon {
            font-size: 23px;
        }
        .active_icon {
            color: #a80000;
        }
    }
}
</style>